import React from 'react';

import { Icon } from '../icons';

export const CloseLightIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M19.394,16 L29.65,5.744 L31.765,3.629 C32.077,3.317 32.077,2.81 31.765,2.498 L29.502,0.235 C29.19,-0.077 28.683,-0.077 28.371,0.235 L16,12.606 L3.629,0.234 C3.317,-0.078 2.81,-0.078 2.498,0.234 L0.234,2.497 C-0.078,2.809 -0.078,3.316 0.234,3.628 L12.606,16 L0.234,28.371 C-0.078,28.683 -0.078,29.19 0.234,29.502 L2.497,31.765 C2.809,32.077 3.316,32.077 3.628,31.765 L16,19.394 L26.256,29.65 L28.371,31.765 C28.683,32.077 29.19,32.077 29.502,31.765 L31.765,29.502 C32.077,29.19 32.077,28.683 31.765,28.371 L19.394,16 Z" />
    </svg>
  );
};
